//LIBRARY

import styled from "styled-components";

//MISC

import { COLORS, BORDER_RADIUS, DEVICE_TYPE } from "constants/variables";

export const MobileCalendarFilterContainer = styled.div`
  width: 42px;
  height: 42px;
  border-radius: 50%;
  background-color: ${COLORS.Yellow};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ImageHamburger = styled.img`
  width: 22px;
  height: 15px;
`;

export const Modal = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  z-index: 900;
  @media (max-width: ${DEVICE_TYPE.mediumDesktop}) {
    justify-content: center;
    align-items: center;
  }
  @media (max-width: ${DEVICE_TYPE.mobileHeader}) {
    justify-content: flex-end;
    align-items: flex-end;
  }
`;

export const ModalContentWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 370px;
  @media (max-width: ${DEVICE_TYPE.mediumDesktop}) {
    width: 406px;
  }
  @media (max-width: ${DEVICE_TYPE.mobileHeader}) {
    width: 100%;
  }
`;

export const ModalContent = styled.div`
  background: ${COLORS.RaisinBlack};
  padding: 24px;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
  gap: 12px;
  @media (max-width: ${DEVICE_TYPE.mediumDesktop}) {
    border-radius: ${BORDER_RADIUS.radius32};
  }
  @media (max-width: ${DEVICE_TYPE.mobileHeader}) {
    border-radius: 0px;
    border-top-right-radius: ${BORDER_RADIUS.radius32};
    border-top-left-radius: ${BORDER_RADIUS.radius32};
  }
`;

export const ModalCloseButton = styled.button`
  position: absolute;
  top: -84px;

  background: ${COLORS.RaisinBlack};
  border-radius: ${BORDER_RADIUS.radius16};
  border: none;
  height: 64px;
  width: 64px;
  z-index: 1000;
  cursor: pointer;
  @media (max-width: ${DEVICE_TYPE.mediumDesktop}) {
    right: 0px;
  }
  @media (max-width: ${DEVICE_TYPE.mobileHeader}) {
    right: 24px;
  }
`;

export const XImg = styled.img`
  width: 32px;
  height: 32px;
`;

export const ImgModal = styled.img`
  border-radius: ${BORDER_RADIUS.radius32};
  height: 536px;
  width: auto;
  max-width: 1600px;
`;

export const FiltersButton = styled.div`
  width: 180px;
  height: 48px;
  background-color: ${COLORS.VividAuburn};
  border-radius: ${BORDER_RADIUS.radius21};
  margin-top: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const FiltersWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  width: 100%;
`;

export const TitleWrapper = styled.div`
  margin-bottom: 12px;
`;
